import { Component } from '@angular/core';
import { MasterComponent, MasterDetailComponent, PanelComponent } from '@rocksoft/cdk';
import { DevicesUnassignedContainerComponent } from '../devices-unassigned/devices-unassigned.container';

@Component({
  selector: 'era-unassigned-devices',
  templateUrl: './unassigned-devices.component.html',
  styleUrls: ['./unassigned-devices.component.scss'],
  imports: [MasterDetailComponent, MasterComponent, PanelComponent, DevicesUnassignedContainerComponent],
})
export class UnassignedDevicesComponent {}
